export const adap_cuenta_hijo = (cuenta) =>{

    let obj = {
        codigoUsuario: cuenta.codigo,
        idUsuario: cuenta.id,
        img: cuenta.img,
        nombre:cuenta.nombre
    }

    return obj;

}